import {getSessionGeneration} from './sessionGeneration.js'

// A refresh owns its own immutable controller and sequence. An older aborted
// response cannot publish into a newer read, another login or a disposed view.
export function createLastHuntReader({read,onState,session=getSessionGeneration}) {
  const generation=session()
  let active=true,sequence=0,controller=null,report=null
  const current=(seq,own)=>active&&generation===session()&&seq===sequence&&!own.signal.aborted
  return {
    dispose(){active=false;sequence++;controller?.abort()},
    async refresh(){
      if(!active||generation!==session())return false
      controller?.abort()
      const own=new AbortController(),seq=++sequence
      controller=own
      onState({status:report?'refreshing':'loading',report,error:null})
      try {
        const result=await read({signal:own.signal})
        if(!current(seq,own))return false
        report=result;onState({status:'ok',report,error:null});return true
      } catch(error) {
        if(!current(seq,own))return false
        onState({status:'error',report,error:String(error?.message||error)});return false
      }
    },
  }
}
